import * as React from "react";
import {EntityField} from "../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../core/genericdocuments/EntityFieldDataType";
import {
	Checkbox,
	FormControl,
	FormControlLabel,
	FormHelperText,
	InputLabel,
	MenuItem,
	Select,
	TextField
} from "@material-ui/core";
import {Utility} from "../../core/Utility";
import DateFnsUtils from "@date-io/date-fns";
import {hr} from "date-fns/esm/locale";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import {LookupDataRow} from "../../services/LookupDataRow";
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails";
import ChipInput from "material-ui-chip-input";
import ErrorBoundary from "../../core/components/ErrorBoundary";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {t} from "../../core/localization";
import {Validator} from "../../core/Validator";

export interface FieldViewProps {
	field: EntityField<any>
	formState: any
	value: any
	setFormState: (newState: any) => void
	validationState: any
	autoFocus?: boolean,
	handleInputChange: (fieldName: string, value: any) => void,
	lookupData?: (lookupEntity: LookupEntities) => LookupDataRow[],
}

export interface FieldViewState {
}

export class FieldView extends React.Component<FieldViewProps, FieldViewState> {

	constructor(props: FieldViewProps) {
		super(props)
	}

	componentDidMount() {
	}

	componentWillMount() {
	}

	render(): React.ReactNode {
		return (
			<ErrorBoundary>
				<div style={{padding: '0'}}>
					{this.renderForm()}
				</div>
			</ErrorBoundary>
		);
	}

	renderForm(): React.ReactNode {

		const fieldName = this.props.field.name
		const validationError = this.props.validationState && this.props.validationState[fieldName];

		const { validator } = this.props.field;
		let isRequired = false
		if (validator) {
			isRequired = validator.required
		}

		// const label = isRequired ? (this.props.field.label + "*") : this.props.field.label;
		const label = this.props.field.label
		// const addStyle: React.CSSProperties = {};
		// if (validationError) {
		// 	addStyle.borderWidth = "2px";
		// 	addStyle.borderColor = "red";
		// }

		switch (this.props.field.dataType) {
			case EntityFieldDataType._string:
				return this.renderStringField(isRequired, label, validationError)
			case EntityFieldDataType._number:
				return this.renderNumberField(isRequired, label, validationError)
			case EntityFieldDataType._date:
				return this.renderDateField(isRequired, label, validationError)
			case EntityFieldDataType._boolean:
				return this.renderBooleanField(isRequired, label, validationError)
			case EntityFieldDataType._reference:
				return this.renderReferenceField(isRequired, label, validationError)
			case EntityFieldDataType._chips:
				return this.renderChipsField(isRequired, label, validationError)
			case EntityFieldDataType._derived:
				return this.renderDerivedField()
			default:
				return (<div>Not implemented</div>)
		}
	}

	renderStringField(required: boolean, label: string, validationError: string): React.ReactNode {
		const fieldName = this.props.field.name.toString()
		return <TextField
			label={label}
			value={Utility.formatString(this.props.value)}
			onChange={(e) => {this.props.handleInputChange(fieldName, e.target.value)}}
			margin="normal"
			fullWidth
			required={required}
			error={(validationError ? true : false)}
			helperText={validationError}
		/>
	}

	renderNumberField(required: boolean, label: string, validationError: string): React.ReactNode {
		const fieldName = this.props.field.name.toString()
		return <TextField
			label={label}
			type="number"
			value={Utility.formatString(this.props.value)}
			onChange={(e) => {this.props.handleInputChange(fieldName, e.target.value)}}
			margin="normal"
			fullWidth
			required={required}
			error={(validationError ? true : false)}
			helperText={validationError}
		/>	}

	renderDateField(required: boolean, label: string, validationError: string): React.ReactNode {
		const fieldName = this.props.field.name.toString()
		const field = this.props.field
		const maxDate = field.validator && field.validator.maxDate ? field.validator.maxDate : new Date("2100-01-01")
		const minDate = field.validator && field.validator.minDate ? field.validator.minDate : new Date("1900-01-01")
		return <MuiPickersUtilsProvider utils={DateFnsUtils} locale={hr}>
			<KeyboardDatePicker
				margin="normal"
				id="date-picker-dialog"
				label={label}
				format={Utility.PICKER_DATE_FORMAT}
				value={Utility.formatString(this.props.value)}
				onChange={(date) => {this.props.handleInputChange(fieldName, date)}}
				onBlur={null}
				onFocus={null}
				required={required}
				error={(validationError ? true : false)}
				InputLabelProps={{
					shrink: true,
				}}
				maxDate={maxDate}
				minDate={minDate}
			/>
			<FormHelperText>{validationError}</FormHelperText>
		</MuiPickersUtilsProvider>
	}

	renderReferenceField(required: boolean, label: string, validationError: string): React.ReactNode {

		const field = this.props.field
		const fieldName = this.props.field.name.toString()
		const referenceDetails = field.referenceDetails;
		const lookupOptions = referenceDetails.lookupOptions ? field.referenceDetails.lookupOptions() : (this.props.lookupData && referenceDetails.lookupEntity ? this.props.lookupData(referenceDetails.lookupEntity) : []);

		if(field.orderByLabel && lookupOptions) {
			lookupOptions.sort(Utility.compareForSorting('label'));
		}
		// let filterOptions = {};
		// if (referenceDetails.showFilterField === true) {
		// 	filterOptions = {
		// 		filter: true,
		// 		filterPlaceholder: "Filter",
		// 		filterBy: "label"
		// 	};
		// }
		let filteredLookupOptions = lookupOptions
		if (field.filterOptions) {
			filteredLookupOptions = field.filterOptions(this.props.formState, lookupOptions, this.props.lookupData)
			console.log(filteredLookupOptions)
		}
		if (this.props.field.autocomplete) {
			let selectedOption = null
			for (let option of filteredLookupOptions) {
				if (option.value === this.props.value) {
					selectedOption = option
				}
			}
			return (<FormControl required style={{width: '100%', marginTop: '15px'}}>
				<Autocomplete
					options={filteredLookupOptions}
					getOptionLabel={(option: any) => option.label}
					getOptionSelected={(option, value) => option.value === value.value}
					style={{ width: '100%' }}
					value={selectedOption}
					onChange={(e: object, item: any) => this.props.handleInputChange(fieldName, item.value)}
					renderInput={(params) => {
						return <TextField {...params} label={label} margin="normal" required={true} />
					}}
				/>
				{/*<FormHelperText>{Validator.displayFormErrors(this.state.validation.fields, 'customerId').message}</FormHelperText>*/}
			</FormControl>)
		} else {
			return (
				<FormControl required style={{width: '100%', marginTop: '15px'}}>
					<InputLabel>{label}</InputLabel>
					<Select
						value={Utility.formatString(this.props.value)}
						onChange={(e) => {
							this.props.handleInputChange(fieldName, e.target.value)
						}}
						name={fieldName}
						required={required}
						error={(validationError ? true : false)}
						style={{width: '100%'}}>
						{filteredLookupOptions && this.renderOptions(fieldName, filteredLookupOptions)}
					</Select>
				</FormControl>);
		}
	}

	renderOptions(fieldName: string, options: LookupDataRow[]): React.ReactNode[] {
		let items = []
		for (let option of options) items.push(<MenuItem key={`option-${fieldName}-${option.value}`} value={option.value}>{option.label}</MenuItem>)
		return items
	}

	renderChipsField(required: boolean, label: string, validationError: string): React.ReactNode {
		const fieldName = this.props.field.name.toString()
		return (<FormControl style={{width: '100%', marginTop: '15px'}} >
			<div style={{height: '20px', fontSize: '1rem'}}><InputLabel style={{fontSize: '1rem', transform: 'scale(0.75)'}}>{label}</InputLabel></div>
			<ChipInput
				required={required}
				defaultValue={this.props.value}
				onChange={(chips) => this.props.handleInputChange(fieldName, chips)}
			/>
		</FormControl>)
	}

	renderPredefinedChipsField(required: boolean, label: string, validationError: string): React.ReactNode {
		const fieldName = this.props.field.name.toString()
		return (<FormControl style={{width: '100%'}} >
			<div style={{height: '35px', fontSize: '1rem'}}><InputLabel style={{fontSize: '1rem', transform: 'scale(0.75)'}}>{label}</InputLabel></div>
			<ChipInput
				dataSourceConfig={{ text: 'text', value: 'value' }}
				defaultValue={this.props.value}
				onChange={(chips) => this.props.handleInputChange(fieldName, chips)}
			/>
		</FormControl>)
	}

	renderDerivedField(): React.ReactNode {
		return (<div style={{visibility: this.props.field.hide(this.props.formState) ? 'hidden' : "visible"}}>{this.props.value}</div>)
	}

	renderBooleanField(required: boolean, label: string, validationError: string): React.ReactNode {
		const fieldName = this.props.field.name.toString()
		return (<FormControl style={{width: '100%'}} >
			<FormControlLabel
				control={
					<Checkbox
						required={required}
						checked={this.props.value}
						onChange={(e) => this.props.handleInputChange(fieldName, e.target.checked)}
						inputProps={{ 'aria-label': 'primary checkbox' }}
					/>
				}
				label={label}
			/>
			<FormHelperText>{validationError}</FormHelperText>
		</FormControl>)
	}
}
